import React, { Component } from 'react';
import './featersStyles.css';

export default class Features extends Component {
  render() {
    let { project } = this.props;
    return (
      <div className='featureCont ' id='features'>
        <div className='container light'>
          <h2 className='title'>Feateres</h2>
          <hr />
          <div className='feature'>
            {project.features.map((feature, index) => {
              let classes = 'row fetRow';
              if (index % 2 === 0) {
                classes += ' rowRev';
              }
              return (
                <div className={classes} key={'feature-' + index}>
                  <div className='col-md-6'>
                    <div className='subTitle'>{feature.title}</div>
                    <div className='fetDesc'>{feature.desc}</div>
                  </div>
                  <div
                    className='featCont col-md-6'
                    style={{
                      backgroundImage: `url(${feature.img})`,
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: 'rgba(0,0,0,0.7)',
                      }}
                    >
                      <img src={feature.img} alt='' className='fetImg' />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className='otherFeatures'>
            <div className='subtitle'>Other Features</div>
            <div className='featuresList'>
              {project.otherFeatures.map((f, i) => (
                <div className='fetItem' key={'otherFeature-' + i}>
                  {i + 1}) {f}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
